import { ErrorState } from "@common/index";
import { useProductApi } from "@/hooks/apiHooks/useProductApi";
import { useListRead } from "./hooks/useListRead";
import { ProductGrid } from "./components/ProductGrid";

// /c/browse/featured (#401 B3): the "Featured Products → View all" page — the
// product each category features (#183), via GET /products/featured. A failed
// read shows its failed state — never an empty grid.
export const BrowseFeatured = () => {
    const { getFeatured } = useProductApi();
    const { items, status, retry } = useListRead(getFeatured);

    return (
        <div data-testid="browse-featured" className="bg-base-100">
            <div className="max-w-7xl mx-auto px-2 md:px-4 py-6 md:py-8">
                <h1 className="text-2xl md:text-3xl font-bold text-neutral px-2">
                    Featured Products
                </h1>
                {status === "failed" ? (
                    <ErrorState
                        message="Couldn't load featured items."
                        onRetry={retry}
                    />
                ) : (
                    <ProductGrid
                        products={items}
                        pageNumber={1}
                        totalPages={1}
                        isLoading={status === "loading"}
                    />
                )}
            </div>
        </div>
    );
};
